import { Helmet } from "react-helmet"

export const HelmetComponent = (props) => {
    return <Helmet>
        <title>Agua | HMI {props?.title && `| ${props?.title}`}</title>
    </Helmet>
}